import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { AppState } from './index'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// todo use `useDispatch<AppDispatch>()`
export const useAppDispatch = () => useDispatch()

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
